// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton[disabled] > img {\n  opacity: 0.6;\n}\nbutton[disabled] > img {\n  transition: all 0.2s;\n}\n", ""]);
// Exports
module.exports = exports;
